<div class="col no-pad" [ngSwitch]="showVideos">
  <div *ngSwitchCase="true" class="row" data-test="video-container">
    <div
      class=" col-6 {{ fullScreen }} videos"
      *ngFor="let video of videos; let i = index; trackBy: trackByVideos"
    >
      <a
        [routerLink]="video?.routerLink ? video.routerLink : []"
        *ngIf="!selectionMode"
        [queryParamsHandling]="queryParamsHandling"
        [queryParams]="queryParamsFn(video)"
        [target]="target"
        floAnalytics
        [analyticsProperties]="analyticsPropertiesFn(video)"
      >
        <flo-spotlight
          [title]="video.title"
          [imageUrl]="video.asset_url"
          [duration]="video.duration"
          [publishDate]="video.publish_start_date | isoStringToDate"
          [premium]="video.premium"
          [smallThumbnail]="true"
          (click)="hitSpotlight(video)"
        ></flo-spotlight>
      </a>
      <!--TODO floAnalytics name="Search Results" events="click"-->
      <flo-spotlight
        *ngIf="selectionMode"
        [title]="video.title"
        [imageUrl]="video.asset_url"
        [duration]="video.duration"
        [publishDate]="video.publish_start_date | isoStringToDate"
        [premium]="video.premium"
        [smallThumbnail]="true"
        (click)="hitSpotlight(video)"
      ></flo-spotlight>
    </div>
  </div>
  <div *ngSwitchCase="false">
    <span>{{ notFoundWarning }}</span>
  </div>
</div>
